import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, from, map, switchMap } from 'rxjs';
import { Store } from '@ngrx/store';
import { EventSetupState } from '../../modules/events/create-event/store/event-setup.state';
import { selectOrganizer } from '../../redux/root.state';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root',
})
export class CancellationGuardService {
  constructor(
    private store: Store<{ event: EventSetupState }>,
    private userService: UserService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    return from(this.userService.getUserData()).pipe(
      switchMap(() => this.store.select(selectOrganizer)),
      map((organizer) => organizer?.properties?.hasCancellationPolicy),
    );
  }
}
